var _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnField(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uxihdvxvma"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 718",
    style: {
      fill: "#1fb04b"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 217",
    width: 54,
    height: 54,
    rx: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 409"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 372"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 371",
    transform: "translate(15 10)",
    style: {
      clipPath: "url(#uxihdvxvma)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 698",
    d: "M4.368 0c.208.17.492.294.521.6.036.373.282.5.579.617 1.061.426 2.118.864 3.176 1.3.383.158.761.33 1.147.48a.439.439 0 0 1 .31.476.486.486 0 0 1-.338.45c-1.023.427-2.053.839-3.08 1.257-.531.216-1.063.431-1.588.66a.279.279 0 0 0-.1.217c-.007.986 0 1.972 0 2.958v5.274c.225.027.444.058.664.079.834.08 1.675.117 2.5.244a19.617 19.617 0 0 1 3.72.93 1.362 1.362 0 0 0 .9-.071c1.22-.376 2.431-.785 3.653-1.154.847-.256 1.7-.492 2.563-.691a23.86 23.86 0 0 1 2.158-.377 25.26 25.26 0 0 1 2.018-.189.706.706 0 0 1 .834.731 2.552 2.552 0 0 1-.044.642.3.3 0 0 1-.385.257.319.319 0 0 1-.269-.347c.005-.187 0-.373 0-.583a32.9 32.9 0 0 0-9.852 2.3 5.942 5.942 0 0 0 .623.183c.568.105 1.137.224 1.711.278.7.065 1.409.089 2.114.094 1.792.012 3.583 0 5.4 0 0-.213.011-.422 0-.629a.3.3 0 0 1 .278-.337.314.314 0 0 1 .381.238A1.707 1.707 0 0 1 24 16.2v6.526a1.293 1.293 0 0 1-.231.841.989.989 0 0 1-.776.419q-5.1.01-10.191 0a.338.338 0 0 1-.351-.315.352.352 0 0 1 .307-.387 1.419 1.419 0 0 1 .188 0q4.943 0 9.886.005c.343 0 .427-.207.466-.437a.715.715 0 0 0 0-.117v-1.377H12.773a1.187 1.187 0 0 1-1.076-.93 1.237 1.237 0 0 1 1.3-1.484c3.139.02 6.278.008 9.416.008h.888c0-.492.008-.967-.009-1.441 0-.066-.115-.139-.19-.188-.038-.025-.107 0-.162 0-1.691 0-3.382-.034-5.072.009a15.474 15.474 0 0 1-5.457-.854c-.919-.315-1.849-.6-2.787-.852a14.275 14.275 0 0 0-1.879-.353c-.74-.095-1.487-.131-2.231-.2-.166-.014-.331-.041-.512-.063v4.034a8.308 8.308 0 0 1 .952.075 7.651 7.651 0 0 1 1.288.337.735.735 0 0 1 .511.7c0 .359-.265.527-.528.694a2.91 2.91 0 0 1-1.228.368 6.636 6.636 0 0 1-1 .048 3.511 3.511 0 0 1-1.709-.42 1.468 1.468 0 0 1-.388-.326.656.656 0 0 1 .051-.82.373.373 0 0 0 .082-.2q.007-2.195 0-4.39a.626.626 0 0 0-.014-.083A.733.733 0 0 0 2.9 15H1.021c-.306 0-.361.062-.361.374v7.559c0 .292.03.356.36.355q4.967-.007 9.933 0c.334 0 .463.073.513.287a.337.337 0 0 1-.282.415 1.7 1.7 0 0 1-.188 0c-3.3 0-6.606-.006-9.91.007A1.1 1.1 0 0 1 0 23.43v-8.546a1.133 1.133 0 0 1 1.125-.59c.485.012.97 0 1.456 0h.458v-.306q0-6.443-.006-12.886A1.055 1.055 0 0 1 3.663 0zm.623 5.068.021.05.067-.043 4-1.624-4.088-1.684zm18.3 15.544v-.956H13.008a1.41 1.41 0 0 0-.233.018.484.484 0 0 0-.364.671.531.531 0 0 0 .533.312h6.43q1.936 0 3.872-.006l.041-.037m-19.016-.191c0-.078.009-.147.009-.215V.94a.285.285 0 0 0-.307-.275c-.173-.01-.231.12-.228.28V20.048c0 .268.064.342.331.374a1.746 1.746 0 0 0 .2 0M5 19.775v.776a3.509 3.509 0 0 0 2.05-.409A3.958 3.958 0 0 0 5 19.775",
    style: {
      fill: "#1fb04b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 699",
    d: "m39.77 40.394.088.007-.067.043-.021-.05",
    transform: "translate(-34.779 -35.326)",
    style: {
      fill: "#1fb04b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 700",
    d: "m185.25 164.332.041-.037-.041.037",
    transform: "translate(-162.004 -143.684)",
    style: {
      fill: "#1fb04b"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(19 46)",
    style: {
      fontSize: 10,
      fontFamily: "Pretendard-Bold,Pretendard",
      fontWeight: 700,
      letterSpacing: "-.001em",
      fill: "#1fb04b"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD544\uB4DC")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnField);
export default __webpack_public_path__ + "static/media/icn_field.e4164fb30fa80cbf10005231cb663357.svg";
export { ForwardRef as ReactComponent };